// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1SFI5","name":"ConsentHeader_name__2tYpD","birthday":"ConsentHeader_birthday__3XlkM","skeleton":"ConsentHeader_skeleton__2onuw"};